import { Component, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../../../../services/app.service';
import { UserSearchRequest } from '../../../../models/net/request/user-search-request';
import { User } from '../../../../models/data/identity/user';
import { UserService } from '../../../../services/identity/users/user.service';
import { SearchComponent } from '../../../base/search/search.component';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SessionService } from '../../../../services/session/session.service';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css', '../../../../app.component.css']
})

export class UsersComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "UserUID", "Delete"];
    public override searchRequest: UserSearchRequest = new UserSearchRequest();
    public override searchResult: User[] = [];
    //public searchRequestTypeEnum: SearchRequestTypeEnum = SearchRequestTypeEnum.UserSearchRequest;
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: UserService) {

        super(appService, sessionService, itemService, "user", "User");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.UserSearchRequest;
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: UserSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var searchRequest: UserSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (searchRequest) {

                this.runSearch(searchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: User) => i.UserId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: UserSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
